import {
    IconButton,
    ListItemIcon,
    ListItemText,
    ListItem,
    MenuList,
    List,
    Badge,
    MenuItem,
    Menu,
    Backdrop,
    Divider,
    useMediaQuery,
    BottomNavigation,
    Paper,
    SwipeableDrawer,
    BottomNavigationAction
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { updateUserStore } from '../../../redux/actions/user';

import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import Avatar from '../Avatar';
import pusher from '../../utils/pusher';
import UserMenu from './UserMenu';
import CloseButton from '../CloseButton';

import './style.scss';
import { NUT_THEME_USERS, ROLES } from '../../utils/constants';
import { setDarkmode } from '../../../redux/actions';
import useDidMountEffect from '../../utils/useDidMountEffect';


const SidebarMenu = ({
    convIndex,
    convList
}) => {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width: 899px)');

    const [open, setOpen] = useState(false);
    const [totalNotif, setTotalNotif] = useState(0);
    const [totalMessages, setTotalMessages] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeSegment, setActiveSegment] = useState('');
    const [isThemeBlk, setIsThemeBlk] = useState(false);

    const userInformation = JSON.parse(localStorage.getItem('user'));

    const handleCloseUserMenu = () => {
        setAnchorEl(null);
        setOpen(false);
    };

    const goTo = path => {
        history.push(path);
    };

    const handleOpenUserMenu = (event) => {
        const el = document.getElementById('user-menu-anchor');
        setAnchorEl(el);
        setOpen(true);
    };

    const getNotifications = () => {
        axios.get('/api/notifications/count')
            .then((response) => {
                setTotalNotif(response.data);
            })
            .catch((error) => {
                console.log({ error });
            });
    };

    const getMessages = () => {
        axios.get('/api/messages/unread-count')
            .then(response => {
                setTotalMessages(response.data);
            })
            .catch((error) => {
                console.log({ error });
            });
    };

    const subscribeToPusher = () => {
        const channel = pusher.subscribe(`private-notifications-${localStorage.getItem('loggedin_user')}`);
        channel.bind('App\\Events\\NotificationEvent', (d) => {
            getNotifications();
        });
    };

    // @todo: refactor
    const subscribeToMessagePusher = () => {
        const channel = pusher.subscribe(`private-new-message-${localStorage.getItem('loggedin_user')}`);
        channel.bind('App\\Events\\NewMessageEvent', (d) => {

            getMessages();
            const activeConversation = convIndex !== null && convIndex >= 0 && convList && convList.length > 0
                ? convList[convIndex]
                : null;
            const isNotSender = userInformation && userInformation.login !== d.senderName;

            if ((!activeConversation && isNotSender)
                || (userInformation && activeConversation && userInformation.id != activeConversation.other_user && isNotSender)
                || (convIndex < 0 && isNotSender)
                || (convList && convList.length <= 0 && isNotSender)
            ) {
                const fc = d;
                window.dispatchEvent(new CustomEvent('header/new-message', { detail: fc }));
            }
        });
    };

    useEffect(() => {
        subscribeToPusher();
        subscribeToMessagePusher();
        getNotifications();
        getMessages();

        if (!userInformation || Object.keys(userInformation).length <= 0) {
            const userOnStorage = JSON.parse(localStorage.getItem('user'));

            if (userOnStorage && Object.keys(userOnStorage).length > 0) {
                dispatch(updateUserStore(userOnStorage));
            } else {
                localStorage.clear();
                window.location('/login');
            }
        }

        setActiveSegment(location.pathname.replace('/', ''));

        const lsDarkmode = JSON.parse(localStorage.getItem('darkmode'));

        if (lsDarkmode) {
            dispatch(setDarkmode(true));
        } else {
            dispatch(setDarkmode(false));
        }


        // Black theme
        if (!isThemeBlk) {
            if (lsDarkmode) {
                document.body.classList.add('darkmode');
                document.body.classList.remove('lightmode');
            } else {
                document.body.classList.add('lightmode');
                document.body.classList.remove('darkmode');
            }
        }

        if (isThemeBlk) {
            document.body.classList.add('darkmode');
            document.body.classList.remove('lightmode');
        }

        return () => { };
    }, []);

    useEffect(() => {
        setActiveSegment(location.pathname.replace('/', ''));

        return () => {

        };
    }, [location]);

    useEffect(() => {
        if (userInformation && Object.keys(userInformation).length > 0) {
            if (NUT_THEME_USERS.includes(userInformation.id)) {
                setIsThemeBlk(true);
            }
        }
    }, [userInformation]);

    useDidMountEffect(() => {
        getMessages();
    }, [convIndex]);


    const RenderUserMenu = () => {
        return <React.Fragment>
            <div className="pop__avatar">
                <Avatar
                    id="header-avatar"
                    size="50"
                    story={false}
                    pu={userInformation}
                    blueBorder={false}
                    showOnline={true}
                />

                <CloseButton
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: '10px'
                    }}
                    onClick={handleCloseUserMenu}
                />
            </div>
            <div className="pop__details">
                {userInformation.firstname || userInformation.lastname
                    ? <React.Fragment><strong>{userInformation.firstname} {userInformation.lastname}</strong>< br /></React.Fragment>
                    : null
                }
                <Link to={`/${userInformation.login}`}>@{userInformation.login}</Link>
            </div>
            <Divider />
            <UserMenu setOpen={setOpen} />
        </React.Fragment>;
    };


    return <div className="sidebar-container">
        {
            !isMobile
                ? <MenuList
                    className='sidebar-menu'
                    sx={{ paddingTop: 1, paddingBottom: 1, zIndex: 1 }}
                >
                    <MenuItem
                        id="user-menu-anchor"
                        onClick={handleOpenUserMenu}
                        disableRipple
                    >
                        <ListItemIcon>
                            <IconButton
                                size="small"
                                sx={[
                                    { pl: 0 },
                                ]}
                                disableRipple
                            >
                                <Avatar
                                    id="header-avatar"
                                    size="50"
                                    story={false}
                                    pu={userInformation}
                                    blueBorder={false}
                                />
                            </IconButton>
                        </ListItemIcon>
                        <ListItemText>
                        </ListItemText>
                    </MenuItem>
                    <MenuItem
                        onClick={() => goTo('/home')}
                        selected={activeSegment == 'home' || activeSegment == ''}
                    >
                        <ListItemIcon>
                            <span className='header-icon'>
                                <i className="fa-regular fa-house-blank"></i>
                            </span>
                        </ListItemIcon>
                        <ListItemText className="header-text">Home</ListItemText>
                    </MenuItem>
                    <MenuItem
                        onClick={() => goTo('/my-notification')}
                        selected={activeSegment == 'my-notification'}
                    >
                        <ListItemIcon>
                            <Badge
                                badgeContent={totalNotif}
                                color='error'
                                sx={{
                                    '& .MuiBadge-badge': {
                                        right: '10px',
                                        top: '4px;'
                                    }
                                }}
                            >
                                <span className='header-icon'>
                                    <i className="fa-regular fa-heart"></i>
                                </span>
                            </Badge>
                        </ListItemIcon>
                        <ListItemText className="header-text">Notifications</ListItemText>
                    </MenuItem>
                    <MenuItem
                        onClick={() => goTo('/messages')}
                        selected={activeSegment == 'messages'}
                    >
                        <ListItemIcon>
                            <Badge
                                badgeContent={totalMessages}
                                color='error'
                                sx={{
                                    '& .MuiBadge-badge': {
                                        right: '10px',
                                        top: '4px;'
                                    }
                                }}
                            >
                                <span className='header-icon'>
                                    <i className="fa-regular fa-messages"></i>
                                </span>
                            </Badge>
                        </ListItemIcon>
                        <ListItemText className="header-text">Messages</ListItemText>
                    </MenuItem>
                    {
                        userInformation.role === ROLES.PU
                            ? <MenuItem
                                onClick={() => goTo('/promotion')}
                                selected={activeSegment == 'promotion'}
                            >
                                <ListItemIcon>
                                    <span className='header-icon'>
                                        <i className="fa-regular fa-badge-percent"></i>
                                    </span>
                                </ListItemIcon>
                                <ListItemText className="header-text">Promotion</ListItemText>
                            </MenuItem>
                            : null
                    }
                    {
                        userInformation.role === ROLES.SU
                            ? <MenuItem
                                onClick={() => goTo('/following')}
                                selected={activeSegment == 'following'}
                            >
                                <ListItemIcon>
                                    <span className='header-icon'>
                                        <i className="fa-regular fa-user-plus"></i>
                                    </span>
                                </ListItemIcon>
                                <ListItemText className="header-text">Subscriptions</ListItemText>
                            </MenuItem>
                            : null
                    }

                    {
                        userInformation.role === ROLES.PU
                            ? <MenuItem
                                onClick={() => goTo('/followers')}
                                selected={activeSegment == 'followers'}
                            >
                                <ListItemIcon>
                                    <span className='header-icon'>
                                        <i className="fa-solid fa-people-group"></i>
                                    </span>
                                </ListItemIcon>
                                <ListItemText className="header-text">Followers</ListItemText>
                            </MenuItem>
                            : null
                    }
                    <MenuItem
                        onClick={() => goTo(`/${userInformation.login}`)}
                        selected={activeSegment == userInformation.login}
                    >
                        <ListItemIcon>
                            <span className='header-icon'>
                                <i className="fa-regular fa-user"></i>
                            </span>
                        </ListItemIcon>
                        <ListItemText className="header-text">My Profile</ListItemText>
                    </MenuItem>
                    <MenuItem
                        onClick={handleOpenUserMenu}
                        disableRipple
                    >
                        <ListItemIcon>
                            <span className='header-icon'>
                                <i className="fa fa-ellipsis-h"></i>
                            </span>
                        </ListItemIcon>
                        <ListItemText className="header-text">More</ListItemText>
                    </MenuItem>
                </MenuList>
                : <Paper
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 9
                    }}
                    elevation={3}
                >
                    <BottomNavigation
                        className='sidebar-menu'
                        value={activeSegment}
                    >
                        <MenuItem
                            onClick={() => goTo('/home')}
                            selected={activeSegment == 'home' || activeSegment == ''}
                            value='home'
                        >
                            <ListItemIcon>
                                <span className='header-icon'>
                                    <i className='fa-regular fa-house-blank' />
                                </span>
                            </ListItemIcon>
                        </MenuItem>
                        <MenuItem
                            onClick={() => goTo('/my-notification')}
                            selected={activeSegment == 'my-notification'}
                            value='my-notification'
                        >
                            <ListItemIcon>
                                <Badge
                                    badgeContent={totalNotif}
                                    color='error'
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            right: '6px',
                                            top: '4px;'
                                        }
                                    }}
                                >
                                    <span className='header-icon'>
                                        <i className="fa-regular fa-heart"></i>
                                    </span>
                                </Badge>
                            </ListItemIcon>
                        </MenuItem>
                        {
                            userInformation.role === ROLES.PU
                                ? <MenuItem
                                    onClick={() => goTo('/create')}
                                    selected={activeSegment == 'create'}
                                    value='create'
                                >
                                    <ListItemIcon>
                                        <span className='header-icon'>
                                            <i className='fa-solid fa-plus' />
                                        </span>
                                    </ListItemIcon>
                                </MenuItem>
                                : null
                        }
                        <MenuItem
                            onClick={() => goTo('/messages')}
                            selected={activeSegment == 'messages'}
                            value='messages'
                        >
                            <ListItemIcon>
                                <Badge
                                    badgeContent={totalMessages}
                                    color='error'
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            right: '6px',
                                            top: '4px;'
                                        }
                                    }}
                                >
                                    <span className='header-icon'>
                                        <i className="fa-regular fa-messages"></i>
                                    </span>
                                </Badge>
                            </ListItemIcon>
                        </MenuItem>
                        <MenuItem
                            id="user-menu-anchor"
                            onClick={handleOpenUserMenu}
                        >
                            <ListItemIcon>
                                <IconButton
                                    size="small"
                                    sx={{ pl: 0 }}
                                >
                                    <Avatar
                                        id="header-avatar"
                                        size="40"
                                        story={false}
                                        pu={userInformation}
                                        blueBorder={false}
                                    />
                                </IconButton>
                            </ListItemIcon>
                        </MenuItem>
                    </BottomNavigation>
                </Paper>
        }


        {
            !isMobile
                ? <Backdrop
                    open={open}
                    sx={{
                        '& .MuiBackdrop-root': {
                            zIndex: 999
                        }
                    }}
                >
                    <Menu
                        id="sidebarMenuPop"
                        aria-labelledby='userMenuTrigger'
                        className='sidebar-menu__pop'
                        open={open}
                        onClose={handleCloseUserMenu}
                        onClick={handleCloseUserMenu}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        transitionDuration={0}
                    >
                        <RenderUserMenu />
                    </Menu>
                </Backdrop>
                : <SwipeableDrawer
                    id="sidebarMenuPop"
                    className='sidebar-menu__pop'
                    anchor='right'
                    open={open}
                    onClose={handleCloseUserMenu}
                    onOpen={() => { }}
                >
                    <RenderUserMenu />
                </SwipeableDrawer>
        }

    </div >;
};

const mapStateToProps = state => ({
    convIndex: state.message.convIndex,
    convList: state.message.convList,
});

export default connect(mapStateToProps)(SidebarMenu);